import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./table-pagination.i18n";

type TablePaginationProps = {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export function TablePagination({
  page,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
}: TablePaginationProps) {
  const t = useT(T);

  if (totalCount <= pageSize) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);

  const summary = t.showingResults({
    from: from.toString(),
    to: to.toString(),
    total: totalCount.toString(),
  });

  const pageOf = t.pageOf(page.toString(), totalPages.toString());

  return (
    <div className="flex items-center justify-between mt-4">
      <div className="text-sm text-muted-foreground">{summary}</div>
      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground">{pageOf}</span>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
          >
            {t.previous}
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
          >
            {t.next}
          </Button>
        </div>
      </div>
    </div>
  );
}
